Ext.define('SA.view.manageproject.ViewsListItem', {
    alias: 'widget.manage-project-views-list-item',
    extend: 'Ext.Component',

    cls: 'sa-manage-project-view-list-item',
    saAnim: true,

    initComponent() {
        var projectView = this.projectView,
            icon = SA.view.ViewTypes.getIcon(projectView.getType());

        this.html = [
            '<svg class="sa-manage-project-view-list-item-icon"><use href="#', icon, '"></use></svg>',
            '<span class="sa-manage-project-view-list-item-name"></span>',
            '<a class="sa-manage-project-list-item-button sa-manage-project-view-list-item-move-up" title="Move up"></a>',
            '<a class="sa-manage-project-list-item-button sa-manage-project-view-list-item-move-down" title="Move down"></a>',
            '<a class="sa-manage-project-list-item-button sa-manage-project-list-item-menu-button">',
                '<div class="sa-manage-project-list-item-dot"></div>',
                '<div class="sa-manage-project-list-item-dot"></div>',
                '<div class="sa-manage-project-list-item-dot"></div>',
            '</a>'
        ];

        this.callParent();
    },

    afterRender() {
        this.callParent();

        this.refresh();
    },

    initEvents() {
        var el = this.el,
            projectView = this.projectView,
            project = projectView.getProject(),
            menu;

        el.on({
            scope: this,

            mouseout() {
                el.removeCls('sa-manage-project-view-list-item-hover');
            },

            mouseover() {
                el.addCls('sa-manage-project-view-list-item-hover');
            }
        });

        el.on({
            delegate: '.sa-manage-project-view-list-item-move-down',

            click() {
                var index = project.getViews().indexOf(projectView);

                project.moveView(index, index + 1);

                project.save();
            }
        });

        el.on({
            delegate: '.sa-manage-project-view-list-item-move-up',

            click() {
                var index = project.getViews().indexOf(projectView);

                project.moveView(index, index - 1);

                project.save();
            }
        });

        el.on({
            delegate: '.sa-manage-project-list-item-menu-button',

            click: (ev, target) => {
                if (menu && menu.wasRecentlyVisible()) {
                    return;
                }

                Ext.fly(target).addCls('sa-manage-project-list-item-button-active');

                menu = Ext.widget({
                    xtype: 'menu',
                    cls: 'sa-manage-project-view-list-menu',
                    track: true,

                    items: [
                        {
                            disabled: project.getViews().indexOf(projectView) === 0,
                            text: 'Move to top',

                            handler() {
                                project.moveView(projectView, 0);

                                project.save();
                            }
                        }, {
                            text: 'Rename',

                            handler: () => {
                                Ext.widget({
                                    xtype: 'rename-menu',

                                    name: projectView.getName(),
                                    positionEl: target,
                                    target: this,

                                    handler(name) {
                                        projectView.setName(name);
                                        projectView.save();
                                    }
                                });
                            }
                        }, {
                            text: 'Delete',

                            handler() {
                                project.removeView(projectView);
                                project.save();
                            }
                        }
                    ],

                    listeners: {
                        hide(menu) {
                            Ext.destroy(menu);

                            Ext.fly(target).removeCls('sa-manage-project-list-item-button-active');
                        }
                    },

                    plugins: [{
                        ptype: 'sa-arrow'
                    }]
                });

                menu.getPlugin('sa-arrow').setTarget(target);

                menu.showBy(target, 'tr-br?', [4, 7]);
            }
        });
    },

    refresh() {
        var el = this.el,
            view = this.projectView;

        el.down('.sa-manage-project-view-list-item-name', true).innerHTML = Ext.util.Format.htmlEncode(view.getName());
        el.ifCls(!view.isViewable(), 'sa-manage-project-view-list-item-error');
    }
});
